<div class="xp-section-header__lead">
	<h2 class="xp-section-header__title">{{ heading() }}</h2>
	<span *ngIf="note()" class="xp-section-header__note">{{ note() }}</span>
	<ng-content select="[xpSectionHeaderAside]"></ng-content>
</div>
<div class="xp-section-header__actions"><ng-content></ng-content></div>
